import { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import style from '../scss/navbar.module.scss';
import LanguageDropdown from './LanguageDropdown';
import DialogComponent from './DialogComponent';
import { TitleH1Component } from './TitleH1Component';
import { TitleH3Component } from './TitleH3Component';
import { useAuth } from 'context/userContext';
import { TextsContext } from 'context/textsContext';

const NavbarComponent = ({ transparent = false }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { texts } = useContext(TextsContext);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const closeLogoutModal = () => setShowLogoutModal(false);

  const rawName = user?.name ?? '';
  const parts = rawName.trim().split(/\s+/).filter(Boolean);
  const displayName = parts.length >= 2 ? `${parts[0]} ${parts[1]}` : parts[0] || '-';
  const initials = parts.length >= 2
    ? `${parts[0][0]}${parts[1][0]}`.toUpperCase()
    : parts[0]?.[0]?.toUpperCase() ?? '-';

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <>
      <header className={`py-2 ${transparent ? style.transparent : 'bg_primary'} ${style.header}`}>
        <div className={`${style.headerbtn} ${transparent ? 'container' : ''}`}>
          <img
            className={style.logo}
            src={'/icons/my_vip_care_navbar_logo.svg'}
            alt={'img logo vumi'}
            role="button"
            onClick={() => navigate('/home')}
          />
          <div className={`d-flex ${style.actions}`}>
            <LanguageDropdown />
            <span className={style.divider} />
            <Link to="/dashboard" className={style.navLink}>
              <Icon icon="mdi:star-box-outline" className={`d-lg-none ${style.icon}`} width={24} height={24} />
              <span className="d-none d-lg-inline">{texts?.dashboard_title ?? 'My Favorite Plan'}</span>
            </Link>
            <span className={style.divider} />
            <div className={style.userInfo}>
              <div className={style.avatar}>
                <span>{initials}</span>
              </div>
              <span className={`d-none d-lg-inline ${style.userName}`}>{displayName}</span>
            </div>
            <span className={style.divider} />
            <button className={style.logoutBtn} onClick={() => setShowLogoutModal(true)}>
              <img src="/icons/power_off.svg" alt="log out" width={24} height={24} />
              <span className="d-none d-lg-inline">{texts?.navbar_logout ?? 'Log Out'}</span>
            </button>
          </div>
        </div>
      </header>

      {/* Mismo modal de confirmación que el de MenuComponent: el botón ya no cierra
          sesión directo, sino que pide confirmación antes de llamar a `handleLogout`. */}
      <DialogComponent
        show={showLogoutModal}
        onClose={closeLogoutModal}
        onCancel={closeLogoutModal}
        onConfirm={handleLogout}
        cancelText={texts?.general_cancel_button ?? 'Cancel'}
        confirmText={
          <span className="d-flex justify-content-center align-items-center">
            <span className="me-2 d-flex"><Icon icon="mdi:logout" width={24} height={24} /></span>
            <span>{texts?.menu_logout ?? 'Cerrar sesión'}</span>
          </span>
        }
      >
        <Icon icon="mdi:logout" width={32} height={32} className="color_primary_2 mb-3" />
        <TitleH1Component styleGroup={`raleway fw_700 color_primary_2 mb-2`}>
          {texts?.menu_logout ?? 'Cerrar sesión'}
        </TitleH1Component>
        <TitleH3Component styleGroup={`raleway py-0 mb-0 color_primary_2 fw_700`}>
          {texts?.menu_logout_phrase ?? '¿Estás seguro que deseas cerrar sesión?'}
        </TitleH3Component>
      </DialogComponent>
    </>
  );
};

export default NavbarComponent;
